module.exports = __webpack_public_path__ + "static/img/web_load.2dc756c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/web_load.gif
// module id = sRXO
// module chunks = 28